export const projects = [
    {
      title: 'Cryptobase',
      description: "Cryptobase is  a premier source for everything crypto related. This app features the latest updates, helps keep track of trending coins as well as allows you create a watch list to keep track of your favorite cryptos.",
        image: '/images/11.png',
        tags: ['React', 'Tailwind CSS', 'Firebase', 'Context API'],
      source: 'https://github.com/izzyben20/cryptobase.git',
      visit: 'https://cryptobasez.netlify.app/',
      id: 6868,
    },
    {
      title: 'CryptoHub',
      description: "CryptoHub is a cryptocurrency news media, a premier source for everything crypto related. This app features the latest updates, converging on daily news in the cryptocurrencies world including Bitcoins, Altcoins and, crypto trading.",
        image: '/images/1.png',
        tags: ['React', 'RTK Query', 'Ant Design', 'Chart-js'],
      source: 'https://github.com/izzyben20/cryptohub.git',
      visit: 'https://cryptohubb.netlify.app/',
      id: 0,
    },
    {
      title: 'Budget App',
      description: "Keep tracks of all your incomes and expenses, your money doesn't have to be messy, get a handle on your personal finances by tracking your incomes & expenses. The overview page help you visualize the flow of your money at a glance.",
        image: '/images/3.png',
        tags: ['React', 'Context Api', 'MUI', 'Chart-js'],
      source: 'https://github.com/izzyben20/budget_app.git',
      visit: 'https://budgett-ap.netlify.app/',
      id: 2,
    },
    {
      title: 'GPT-3',
      description: "GPT-3 is a fictitious landing page for an AI company, this project feature some modern UI design and was originally a figma designed UI. This project was built with react and CSS.",
      image: '/images/4.png',
      tags: ['React', 'CSS'],
      source: 'https://github.com/izzyben20/gpt_figma_design.git',
      visit: 'https://gptai.netlify.app/',
      id: 3,
    },
    {
      title: 'Quiz-App',
      description: "This web quiz app built with react and redux enable users to practice multiple choice or true/false test, it shows progress feedback during quiz play, and at the end, the app also shows the result.",
      image: '/images/5.png',
      tags: ['React', 'Redux', 'MUI', 'API'],
      source: 'https://github.com/izzyben20/quiz-app.git',
      visit: 'https://myquiziz.netlify.app/',
      id: 4,
    },
    {
      title: 'TechJobs',
      description: "TechJobs is a job listing landing page for techies, built with react and styled components.",
      image: '/images/6.png',
      tags: ['React', 'Javascript', 'Styled Components'],
      source: 'https://github.com/izzyben20/tech_jobs.git',
      visit: 'https://techjjobs.netlify.app/',
      id: 5
    },
    {
      title: 'eCash',
      description: "eCash is a virtual bank landing page built on top of React with styled components, react scroll for smooth scrolling animations and react router functionalities.",
      image: '/images/8.png',
      tags: ['React', 'Styled Components', 'React Scroll'],
      source: 'https://github.com/izzyben20/eCash.git',
      visit: 'https://ecashh.netlify.app/',
      id: 7
    },
    {
      title: 'Tesla-Clone',
      description: "This is a clone website of the official Tesla page. The page has similar sections which made duplicating these sections alot easier, this demonstrates the reusablity of react components.",
      image: '/images/7.png',
      tags: ['React', 'Styled Components'],
      source: 'https://github.com/izzyben20/tesla-clone.git',
      visit: 'https://cloneetesla.netlify.app/',
      id: 6
    }
  ];